import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { menuItems } from './BottomNavigation.constants';
import useMenuContext from '../../hooks/useMenuContext';
import { Container, MenuItem } from './BottomNavigation.styled';
import { showScanQrCode, hideScanQrCode } from '../../store/actions/nativeData';
import useCheckModuleBluetooth from '../../hooks/useCheckModuleBluetooth';

const BottomNavigation = ({ className }) => {
  const dispatch = useDispatch();
  const { isQRActive } = useSelector(state => state.app);
  const history = useHistory();
  const location = useLocation();
  const containerRef = useRef();
  const [value, setValue] = useState(null);
  const {
    setVisible: setMenuVisible,
    startHiding: hideMenu,
    visible: menuVisible
  } = useMenuContext();

  const findIndex = itemId => {
    return menuItems.findIndex(({ id }) => id === itemId);
  };

  const isModuleBluetoothEnable = useCheckModuleBluetooth();

  useEffect(() => {
    if (menuVisible) {
      setValue(findIndex('nav_menu_button'));
    } else if (isQRActive) {
      setValue(findIndex('qrcode-scanner'));
    } else {
      const activeItemIndex = menuItems.findIndex(({ path, disabled }) => {
        if (location.pathname === path) {
          return true;
        }
        return disabled && path && location.pathname.startsWith(path);
      });
      setValue(activeItemIndex !== -1 ? activeItemIndex : null);
    }
  }, [location.pathname, menuVisible, isQRActive]);

  useEffect(() => {
    if (containerRef.current) {
      const height = containerRef.current.offsetHeight;
      containerRef.current.parentNode.style.paddingBottom = `${height}px`;
    }
  }, [containerRef]);

  const handleSelectionChange = useCallback(
    (event, newValue) => {
      const menuItem = menuItems[newValue];

      if (!menuItem.openMenu) {
        if (menuVisible) {
          hideMenu();
        }
        if (menuItem.openQRScanner) {
          dispatch(showScanQrCode());
        } else {
          dispatch(hideScanQrCode());
          history.push(menuItem.path);
        }
      } else {
        setMenuVisible(!menuVisible);
      }
    },
    // eslint-disable-next-line
    [history, menuVisible]
  );

  const renderMenuItem = menuItem => {
    const {
      id,
      label,
      disabled,
      Icon,
      withModuleBluetoothDisabled,
      withModuleBluetoothEnabled
    } = menuItem;

    const isHidden =
      (withModuleBluetoothEnabled && !isModuleBluetoothEnable) ||
      (withModuleBluetoothDisabled && isModuleBluetoothEnable);

    return (
      <MenuItem
        disableRipple
        disabled={disabled}
        icon={<Icon />}
        id={id}
        key={label}
        label={label}
        style={isHidden ? { display: 'none' } : {}}
      />
    );
  };

  return (
    <Container
      ref={containerRef}
      value={value}
      className={className}
      onChange={handleSelectionChange}
      showLabels
    >
      {menuItems.map(renderMenuItem)}
    </Container>
  );
};

export default BottomNavigation;
